import { render, staticRenderFns } from "./ProviderPage.vue?vue&type=template&id=57233a80&scoped=true&"
import script from "./ProviderPage.vue?vue&type=script&lang=js&"
export * from "./ProviderPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57233a80",
  null
  
)

export default component.exports